import { type State } from '#types/chat/index.ts'

export const ErrorMessage = ({ error }: Pick<State, 'error'>) =>
	error && (
		<div className="ml-1 flex justify-center gap-0 md:m-auto md:mb-2 md:w-full md:gap-2">
			<span className="text-sm text-red-500">{error}</span>
		</div>
	)
